<template>
  <div
    class="divide-static-default-mid flex flex-col space-y-8 divide-y *:py-12"
  >
    <BaseOrderlineBlock
      v-for="orderLine in order.orderLines"
      :key="orderLine.id"
    >
      <RevTag
        class="w-max"
        :data-qa="orderLine.state.code.toLowerCase()"
        :label="getLabel(orderLine)"
        :variant="getTagVariant(orderLine)"
      />
    </BaseOrderlineBlock>
  </div>
</template>

<script setup lang="ts">
import { RevTag, type Variants } from '@ds/components/Tag'

import type { Order, OrderLine } from '../../../../Tab.types'
import BaseOrderlineBlock from '../BaseOrderlineBlock/BaseOrderlineBlock.vue'

import { TAG_VARIANTS_BY_ORDERLINE_STATE_CODE } from './StatusCell.constants'

defineProps<{ order: Order }>()

function getLabel(orderLine: OrderLine) {
  return orderLine.state.code === 'CANCELLED'
    ? orderLine.cancelInitiator.label
    : orderLine.state.label
}

function getTagVariant(orderLine: OrderLine): Variants {
  return (
    TAG_VARIANTS_BY_ORDERLINE_STATE_CODE[orderLine.state.code] || 'alternate'
  )
}
</script>
